import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import { companyInfo } from "../data/companyData";
import "./LegalPages.css";

export default function TermsOfService() {
  return (
    <LegalPageLayout title="Terms of Service" updated="January 2026">
      <section className="legal-block">
        <h2>1. Agreement to Terms</h2>
        <p>
          By accessing or using the website and SaaS products of Quinterra Software Solutions Pvt.
          Ltd., you agree to be bound by these Terms of Service. If you do not agree, please do not
          use our services.
        </p>
      </section>

      <section className="legal-block">
        <h2>2. Services</h2>
        <p>
          Quinterra provides AI-powered SaaS products for HR, education, CRM, staffing, and enterprise
          operations. Services are offered on a subscription or enterprise licensing basis as described
          in individual product agreements.
        </p>
      </section>

      <section className="legal-block">
        <h2>3. User Accounts</h2>
        <p>
          You are responsible for maintaining the confidentiality of your account credentials and for
          all activities under your account. You must provide accurate information and notify us
          immediately of any unauthorized use.
        </p>
      </section>

      <section className="legal-block">
        <h2>4. Acceptable Use</h2>
        <p>
          You agree not to misuse our services, including attempting unauthorized access, interfering
          with platform operations, uploading malicious code, or using our products for unlawful purposes.
        </p>
      </section>

      <section className="legal-block">
        <h2>5. Intellectual Property</h2>
        <p>
          All content, software, trademarks, and technology associated with Quinterra products remain
          the property of Quinterra Software Solutions Pvt. Ltd. You may not copy, modify, or
          distribute our materials without written consent.
        </p>
      </section>

      <section className="legal-block">
        <h2>6. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Quinterra shall not be liable for indirect,
          incidental, or consequential damages arising from your use of our services. Our total
          liability is limited to the fees paid by you in the preceding twelve months.
        </p>
      </section>

      <section className="legal-block">
        <h2>7. Governing Law</h2>
        <p>
          These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive
          jurisdiction of courts in Hyderabad, Telangana.
        </p>
      </section>

      <section className="legal-block">
        <h2>8. Contact</h2>
        <p>
          {companyInfo.legalName}
          <br />
          Email: <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
          <br />
          Phone: <a href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}>{companyInfo.phone}</a>
        </p>
      </section>
    </LegalPageLayout>
  );
}
